<template>
    <b-row :style="this.guest && !this.guestAuthenticated ? 'max-width:500px;margin:auto;' : this.guest ? 'padding:55px 25px' : ''">
        <h6 class="showing-data__for">Record of clinical supervision</h6>
        <b-col sm="12" class="supervision-container">
            <Pulse loading v-if="isBusy" class="loader" color="#999999" />

          <b-alert v-if="message != null" :show="true" :dismissible="true" @dismissed="messageDismissed" :variant="message.type"> {{ message.message }} </b-alert>

          <b-card>

            <b-container v-if="showSupervisionTypeForm && !guest && !isBusy">
              <b-row>
                <b-button class="ovr-button__inverted" variant="dark" @click="setSupervisionFor('Supervisee')">I am a Supervisor</b-button>
                <b-button class="ovr-button__inverted" variant="dark" @click="setSupervisionFor('Supervisor')">I am a Supervisee</b-button>
              </b-row>

            </b-container>

            <b-container v-if="guest && !this.entryId">
              <b-col style="text-align: center;">
                <p>Please enter the 2FA code sent to the phone number associated with the reviewee of this supervision record</p>
                <FreeTextFormItem :item="this.authenticationCode" />
                <div style="width: 100%;display: flex;justify-content: space-between;">
                  <b-button class="ovr-button__inverted" variant="dark" @click="authenticateUser">Submit</b-button>
                  <b-button class="ovr-button__inverted" variant="dark" @click="resendAuthCode" :disabled="resendCooldown > 0">
                    <span v-if="resendCooldown === 0">Re-send</span>
                    <span v-else>Re-send ({{ resendCooldown }})</span>
                  </b-button>
                </div>
              </b-col>

            </b-container>

            <Form @handleTitleInput="messageDismissed" :load-form="loadForm" ref="form" :entry-id="entryId" @show-message="showMessage" @hide-message="messageDismissed"
                  @loading-started="isBusy = true" @loading-entry="entrySubmitted" @loading-finished="isBusy = false"
                  :form="form" :hide-fields="hideFields" :extra-fields="extraFields"
                  v-if="form && !showSupervisionTypeForm" v-show="!isBusy" />
          </b-card>

        </b-col>
    </b-row>
</template>

<script>
import Form from '../../../components/form/Form';
import Pulse from '../../../components/loaders/Pulse'
import FreeTextFormItem from "@/components/form/FreeTextFormItem.vue";
import ContactSelect from "@/components/form/ContactSelect.vue";
import Providers from "@/providers";
import shallowNavigation from '../../../mixins/shallowNavigation';
import { mapGetters } from "vuex";

export default {
    name: "Supervision",
    mixins: [shallowNavigation],
    components: {FreeTextFormItem, Form, Pulse },
    computed: {
        ...mapGetters("userProfile", ["getFullName", "getProfile"]),
    },
    data: function () {
        return {
            isBusy: false,
            form: null,
            message: null,
            entryId:null,
            showSupervisionTypeForm:true,
            guest:false,
            guestAuthenticated:false,
            authenticationCode: {title: '2FA Code',value:  ''},
            resendCooldown: 0,
            resendInterval: null,
            hideFields: [],
            extraFields: [],
        }
    },
    mounted: function () {},
    methods: {
        prepareForFieldInjection()
        {
          this.form.extra = this.form?.extra || {};
          this.form.reviewee = {
              // ensure these fields exist for watch()
              RevieweeName: this.form.reviewee?.RevieweeName || "",
              RevieweeEmail: this.form.reviewee?.RevieweeEmail || "",
              RevieweeNumber: this.form.reviewee?.RevieweeNumber || "",
              RevieweeType: this.form.reviewee?.RevieweeType || this.form.extra?.role || "",
              ...this.form?.reviewee
          };
          this.syncRevieweeFromSavedPartyFields();
          this.injectContactSelect();
        },
        syncRevieweeFromSavedPartyFields()
        {
          // Shared supervisions already have reviewee populated by the API.
          if (this.form.reviewee?.ExpiresAt) {
            return;
          }

          const revieweeType = this.form.reviewee.RevieweeType || this.form.extra?.role;
          if (!revieweeType) {
            return;
          }

          const isSupervisor = revieweeType === "Supervisee";
          const nameField = isSupervisor ? "supervise" : "supervisor";
          const email = this.form.extra?.["supervision-contact"] || this.form.reviewee.RevieweeEmail || "";

          this.form.reviewee.RevieweeType = revieweeType;
          this.form.reviewee.RevieweeEmail = email;
          this.form.reviewee.RevieweeName =
            this.form.reviewee.RevieweeName
            || this.form.extra?.["supervision-contact-name"]
            || this.$formTools.getItemValue(this.form, nameField)
            || "";
          this.form.reviewee.RevieweeNumber =
            this.form.reviewee.RevieweeNumber
            || this.form.extra?.["supervision-contact-phone"]
            || "";
        },
        hydrateRevieweePhoneFromContacts()
        {
          if (this.form.reviewee?.ExpiresAt || this.form.reviewee?.RevieweeNumber) {
            return Promise.resolve();
          }

          const email = this.form.reviewee?.RevieweeEmail || this.form.extra?.["supervision-contact"];
          if (!email) {
            return Promise.resolve();
          }

          return Providers.profile
            .getReviewerContacts()
            .then((items) => {
              const contacts = Array.isArray(items) ? items : [];
              const match = contacts.find((contact) => contact.email === email);
              if (!match) {
                return;
              }

              if (!this.form.reviewee.RevieweeName) {
                this.form.reviewee.RevieweeName = match.full_name || "";
              }
              if (!this.form.reviewee.RevieweeNumber) {
                this.form.reviewee.RevieweeNumber = match.phone || "";
              }

              this.injectContactSelect();
            })
            .catch(() => {});
        },
        setSupervisionFor(supervisionFor)
        {
          this.showSupervisionTypeForm = false;
          this.form.extra.role = supervisionFor;
          this.form.reviewee.RevieweeType = supervisionFor;

          this.prefillSelectedRoleFields(supervisionFor);
          this.injectContactSelect();
        },
        prefillSelectedRoleFields(supervisionFor)
        {
          const fullName = this.getFullName;
          const jobTitle = this.getProfile?.jobTitle || "";

          if (supervisionFor === "Supervisee")
          {
            this.$formTools.setItemValue(this.form, "supervisor", fullName);
            this.$formTools.setItemValue(this.form, "supervisor_role", jobTitle);
          }
          else if (supervisionFor === "Supervisor")
          {
            this.$formTools.setItemValue(this.form, "supervise", fullName);
            this.$formTools.setItemValue(this.form, "supervise_role", jobTitle);
          }
        },
        injectContactSelect()
        {
          const supervisionFor = this.form.reviewee.RevieweeType;

          console.log("Injecting contact select for supervision type:", supervisionFor);

          if (!supervisionFor)
          {
            this.hideFields = [];
            this.extraFields = [];
            return;
          }

          const currentUserIsSupervisor = supervisionFor === "Supervisee";
          const selectedEmail = this.form?.extra?.['supervision-contact'] || this.form.reviewee?.RevieweeEmail;

          this.hideFields = currentUserIsSupervisor
            ? ["supervise", "supervise_role"]
            : ["supervisor", "supervisor_role"];

          this.extraFields = [{
            key: "supervision-contact",
            // always after 'supervisor_role' so it's always after visible supervisor/supervisee fields
            insertAfterIdentifier: "supervisor_role", 
            controlType: "custom",
            component: ContactSelect,
            props: {
              title: currentUserIsSupervisor ? "Supervisee" : "Supervisor",
              selectedEmail: selectedEmail || "",
              disabled: !!this.form?.reviewee?.ExpiresAt,
              currentContact: this.currentContact(),
              profileLink: this.$router.resolve({ name: "profile" }).href,
            },
            onUpdate: this.handleReviewerContactSelected,
          }];
        },
        currentContact()
        {
          if(!this.form?.reviewee?.RevieweeEmail)
          {
            return null;
          }

          // Identity only — never pass form role fields here.
          // The form's role values are unrelated to the contact's job title.
          return {
            full_name: this.form.reviewee.RevieweeName,
            email: this.form.reviewee.RevieweeEmail,
            phone: this.form.reviewee.RevieweeNumber,
            current: true
          };
        },
        handleReviewerContactSelected(selectedContact)
        {
          if (!selectedContact)
          {
            return;
          }

          // Update the OTHER party's name/role only — never overwrite the current user's role.
          // Role comes only from the selected contact's own job_title — no profile/form fallback.
          const revieweeType = this.form.reviewee.RevieweeType;
          const targetNameIdentifier = revieweeType === "Supervisee" ? "supervise" : "supervisor";
          const targetRoleIdentifier = revieweeType === "Supervisee" ? "supervise_role" : "supervisor_role";
          this.$formTools.setItemValue(this.form, targetNameIdentifier, selectedContact.full_name || "");
          this.$formTools.setItemValue(this.form, targetRoleIdentifier, selectedContact.job_title || "");

          // Update share popup state to reflect selected contact
          this.form.extra["supervision-contact"] = selectedContact.email || "";
          this.form.extra["supervision-contact-name"] = selectedContact.full_name || "";
          this.form.extra["supervision-contact-phone"] = selectedContact.phone || "";
          this.form.reviewee.RevieweeEmail = selectedContact.email || "";
          this.form.reviewee.RevieweeName = selectedContact.full_name || "";
          this.form.reviewee.RevieweeNumber = selectedContact.phone || "";
        },
        loadForm: function ()
        {
          if(this.$route.meta && this.$route.meta.guest)
          {
            this.initiateUserAuthentication();
          }
          else if (this.$route.params && this.$route.params.id !== undefined)
          {
              this.showSupervisionTypeForm = false;
              this.loadExistingEntry(this.$route.params.id);
          }
          else
          {
            this.loadNewForm();
          }
        },
        initiateUserAuthentication: function()
        {
          this.guest = true;

          this.$api.v2.post(`supervision/authenticate/`+this.$route.params.id,
              {authenticationCode:null})
          .then((resp) =>
          {
            this.$success('authentication initiated Successfully', resp.body.message);
          })
          .catch((resp) =>
          {
            this.$httpError('Failed to initiate authentication', resp);
          });

        },
        resendAuthCode: function ()
        {
          if (this.resendCooldown > 0) return;
          this.loadForm();
          this.resendCooldown = 30;
          if (this.resendInterval) clearInterval(this.resendInterval);
          this.resendInterval = setInterval(() => {
            if (this.resendCooldown > 0) {
              this.resendCooldown--;
            }
            if (this.resendCooldown === 0) {
              clearInterval(this.resendInterval);
              this.resendInterval = null;
            }
          }, 1000);
        },

        /** 
         * Three entrypoints can lead to loading this component:
         * 1) Guest user clicks on shared supervision link -> needs to authenticate with 2FA
         * 2) Authenticated user clicks on shared supervision link
         * 3) Authenticated user clicks on "Create Supervision Record" 
        */
        authenticateUser: function()
        {
          this.isBusy = true;

          this.$api.v2.post(`supervision/authenticate/`+this.$route.params.id,
     {
             authenticationCode:this.authenticationCode.value
           })
          .then((resp) =>
          {
            this.$success('authentication submitted Successfully', resp.body.message);

            if(resp.body.message !== 'Authentication code expired.')
            {
              this.entryId = this.$route.params.id;
              this.guestAuthenticated = true;
              this.showSupervisionTypeForm = false;
              this.form = resp.body;
              this.form.guest = true;
              this.form.shared = true;

            }

            this.isBusy = false;
          })
          .catch((resp) =>
          {
            this.$httpError('Failed to complete authentication', resp);
          });

        },
        loadExistingEntry: function (id)
        {
            this.isBusy = true;
            this.entryId = id;

            this.$api.v2.get('form/entry/' + id).then(response => {
                this.form = response.body;

                // Enttry only contains ExpiresAt if it has been shared
                if(this.form.reviewee?.ExpiresAt)
                {
                  this.form.shared = true;
                  this.showSupervisionTypeForm = false;
                }
                else
                {
                  this.form.shared = false;
                  this.showSupervisionTypeForm = !this.form?.extra?.role;
                }

                this.prepareForFieldInjection();
                this.hydrateRevieweePhoneFromContacts();
            }).catch((resp) => {
                this.$httpError('Failed to load entry', resp);
            }).then(() => {
                this.isBusy = false;
            })
        },
        loadNewForm: function () {
            this.isBusy = true;
            this.$api.v2.get('form/supervision').then(response =>
            {
                this.form = response.body;
                this.prepareForFieldInjection();
            }).catch((resp) =>
            {
                this.$httpError('Failed to load supervision form', resp);
            }).then(() =>
            {
                this.isBusy = false;
            });
        },
        // End of entry points
        entrySubmitted: function () {
            // alert('Received');
        },
        showMessage: function (event) {
            this.message = event;
        },
        messageDismissed: function () {
            this.message = null;
        },
        onLoad: function () {
          this.loadForm();
        }

    }
}
</script>

<style scoped lang="scss">
  .row { width:100%; justify-content:space-around;margin:auto;}

  .showing-data__for {
    font-weight: 600;
    margin-bottom: 8px;
    color: $blue-300;
    width:100%;
    padding-right: 15px;
    padding-left: 15px;
  }
</style>
